import { Component } from '@angular/core';

@Component({
    selector: 'gl-bankcard-tickets-page',
    templateUrl: './bankcard-tickets-page.component.html',
    styleUrls: ['./bankcard-tickets-page.component.scss']
})
export class BankcardTicketsPageComponent {}
